<template>
  <div class="container p-0 hm-min-height-medium">
    <HMModalHeader
      :title="$t('MEDIA_LIBRARY.TITLE.MEDIA_VIEWS')"
      @close="$emit('close')"
    />
    <div class="content">
      <div v-show="!isTableLoading && showEmpty" class="my-4 c-charcoal">
        {{ $t('MEDIA_LIBRARY.TEXT.NO_VIEWS_YET', { mediaTitle }) }}
      </div>
      <div v-show="!isTableLoading && !showEmpty" class="my-4 c-charcoal">
        {{ $t('MEDIA_LIBRARY.TEXT.LIST_OF_STUDENTS_VIEWED', { mediaTitle }) }}
      </div>
      <HMPaginatedTable
        ref="media-views-table"
        api="mediaLibrary/getMediaViews"
        name="media-views-table"
        :fields="this.tableFields"
        :query="query"
      >
        <template slot="full_name" slot-scope="{ data }">
          <span class="c-charcoal">
            {{ data.student_first_name }} {{ data.student_last_name }}
          </span>
        </template>
        <template slot="viewed" slot-scope="{ data }">
          {{ longDateTime(data.viewed) }}
        </template>
      </HMPaginatedTable>
      <HMModalFooter
        :discardButton="$t('GENERAL.BUTTON.CLOSE')"
        @close="$emit('close')"
      >
        <template slot="submit">
          <HMButton
            color="brand"
            :disabled="loading"
            :loading="loading"
            @click="exportToCSV"
          >
            {{ $t('MEDIA_LIBRARY.BUTTON.EXPORT_TO_CSV') }}
          </HMButton>
        </template>
      </HMModalFooter>
    </div>
  </div>
</template>

<script>
import { longDateTime } from '@/core/utils/events';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'MediaViewsModal',
  components: {},
  props: {
    media: {
      type: Object,
    },
  },
  computed: {
    query() {
      return {
        mediaId: this.media.id,
      };
    },
    mediaTitle() {
      return this.media.title;
    },
    table() {
      return this.$store.state['media-views-table'];
    },
    showEmpty() {
      if (this.table) {
        return this.table.perPage === 0 && !this.table.isLoading;
      }
      return false;
    },
    isTableLoading() {
      if (this.table) {
        return this.table.isLoading;
      }
      return false;
    },
  },
  data() {
    return {
      loading: false,
      tableFields: [
        {
          name: 'full_name',
          title: this.$t('MEDIA_LIBRARY.TABLE.NAME'),
        },
        {
          name: 'viewed',
          title: this.$t('MEDIA_LIBRARY.TABLE.TIME'),
        },
      ],
    };
  },
  methods: {
    longDateTime(date) {
      return longDateTime(date);
    },
    async exportToCSV() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          'mediaLibrary/getMediaViewsCSV',
          this.media.id
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Media Views CSV download failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    // TODO
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
